import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhaladia() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Haldia Industrial Park ',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Haldia Industrial Park ',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Haldia Industrial Park, catering to the transportation needs of factories, refineries, manufacturing units, corporate offices, and logistics hubs across the region. Our fleet of executive sedans, SUVs, MUVs, and premium vehicles ensures safe, comfortable, and on-time travel for employees, supervisors, clients, and senior management. Whether it is daily office commute, shift-based travel, industrial visits, airport transfers, inter-plant movement, business meetings, or VIP travel arrangements, we deliver seamless and hassle-free mobility solutions with trained chauffeurs, flexible rental options, and GPS-enabled well-maintained vehicles, ensuring a premium and dependable corporate transportation experience for businesses operating in and around Haldia Industrial Park.',

    top: 'Top Places to Visit in Haldia with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Haldia Dock Complex",
    "description": "Haldia Dock Complex is one of the major port establishments on India’s eastern coast and a vital trade hub for the region. Operated by the Kolkata Port Trust, the dock plays a crucial role in cargo handling, petrochemical industries, and maritime commerce. The large container yards, vast dockside operations, and ship movements showcase Haldia’s importance as an industrial gateway. While access is restricted, visitors can still appreciate the significance of the port city from nearby viewing points and understand how Haldia grew into one of West Bengal’s most important economic centers."
  },
  {
    "title": "Haldia Riverside Park",
    "description": "Haldia Riverside Park is a scenic leisure spot developed along the banks of the Hooghly River. The park features landscaped gardens, walking paths, fountains, viewing decks, and riverside sitting areas that provide a relaxing environment for families and visitors. Watching ships pass by on the river is a delightful experience, especially during evenings when the lights create a peaceful ambiance. The park is ideal for evening strolls, photography, and unwinding away from the industrial bustle of the city."
  },
  {
    "title": "Balughata Riverside Sunset Point",
    "description": "Balughata Riverside Sunset Point is one of Haldia’s most beautiful natural locations, widely known for its panoramic views, calm surroundings, and breathtaking sunsets. The area features well-laid paths, viewing spaces, and benches along the riverbank, offering a peaceful retreat for residents and travelers alike. The river breeze, local food stalls, and scenic views make it a favorite location for evening outings, nature walks, and photography enthusiasts seeking to capture Bengal’s riverside charm."
  },
  {
    "title": "Haldia Bhawan (City Centre Observation Deck)",
    "description": "Haldia Bhawan, located near the city center, offers an observation tower that provides a bird’s-eye view of the industrial skyline, river routes, and green surroundings of Haldia. The building often hosts exhibitions and official functions, serving as both an administrative and cultural space. For visitors, the observation deck is a unique opportunity to understand Haldia’s layout and industrial development from above. It is one of the best viewing points in the city to appreciate the balance between industry and natural landscapes."
  },
  {
    "title": "Haldia Refinery",
    "description": "Haldia Refinery, operated by Indian Oil Corporation, is one of India’s major petroleum refining units and a key contributor to the nation’s fuel supply. Although entry is closed to the public, the massive industrial complex is an engineering and infrastructural marvel that symbolizes Haldia’s industrial identity. The refinery’s large towers, pipeline systems, and expansive facilities reflect the technological evolution of energy production in eastern India. It stands as a pillar of employment, industrial growth, and strategic economic importance for the region."
  },
  {
    "title": "Marine Drive Road (Haldia)",
    "description": "Haldia’s Marine Drive Road is a scenic coastal stretch that runs alongside the river, lined with trees, green spaces, and viewpoints. It is popular among joggers, cyclists, couples, and families who come to enjoy the peaceful environment, river views, and refreshing breezes. Early mornings and evenings offer the best experience, with the road transforming into a lively walkway filled with residents enjoying the outdoors. It is one of Haldia’s most pleasant and picturesque urban routes."
  },
  {
    "title": "Gopalji Temple",
    "description": "Gopalji Temple is a historic and culturally significant place of worship in Haldia, known for its traditional Bengal temple architecture and peaceful spiritual atmosphere. The temple is dedicated to Lord Krishna and attracts devotees throughout the year, especially during Janmashtami and other festive occasions. Its serene surroundings and devotional environment make it an ideal place for spiritual reflection and traditional worship away from the industrial city setting."
  },
  {
    "title": "City Centre Haldia",
    "description": "City Centre Haldia is a popular shopping and entertainment destination that brings together retail stores, restaurants, cafes, local markets, and entertainment facilities under one area. Families and youth often visit for shopping, casual outings, and festival events. The central location, wide pedestrian spaces, and community-friendly layout make it a lively hub for social interaction and leisure. It reflects the modern urban development of the industrial city."
  },
  {
    "title": "Durgachak",
    "description": "Durgachak is a major township hub in Haldia, known for its markets, business centers, residential sectors, and public utilities. The area is always bustling with shops, eateries, transport connections, and everyday city life. It serves as one of the primary commercial zones where visitors can experience the authentic rhythm of local Haldia living. Whether for shopping, food, or exploring local culture, Durgachak represents the everyday pulse of the city."
  },
  {
    "title": "Haldia IT Park",
    "description": "Haldia IT Park is part of the city’s initiative to expand beyond its industrial identity and promote digital and technological growth. The business complex hosts corporate offices, training centers, and start-ups that contribute to job creation and skilled employment in the region. The modern infrastructure and emerging companies reflect Haldia’s progressive steps toward diversification and urban development. It stands as a symbol of the city’s transition into a more multi-sector economy."
  }
],


"services": [
  {
    "name": "Haldia Industrial Cab",
    "description": "Haldia Industrial Cab provides dedicated corporate transportation for employees and executives commuting to Haldia industrial zones. The service features modern sedans, SUVs, and shuttle vehicles, ensuring safe, timely, and reliable travel with professional drivers and GPS-enabled tracking."
  },
  {
    "name": "Employee Shuttle Haldia",
    "description": "Employee Shuttle Haldia offers high-capacity, scheduled shuttle services for daily workforce commuting within Haldia industrial areas. Features include route optimization, AC minibuses, multi-shift support, and real-time vehicle tracking for efficient employee mobility."
  },
  {
    "name": "Corporate Transport Haldia",
    "description": "Corporate Transport Haldia provides comprehensive transport solutions for companies, including employee commute, executive transfers, and visitor movement. The service ensures punctuality, safety, and professionally managed fleet operations."
  },
  {
    "name": "Factory Worker Transport Haldia",
    "description": "Factory Worker Transport Haldia specializes in transporting factory and industrial workers. It includes structured pick-up/drop routes, multi-shift support, and monitored, secure travel for large workforce teams."
  },
  {
    "name": "Business Cab Haldia",
    "description": "Business Cab Haldia delivers premium corporate travel services for meetings, client visits, airport transfers, and executive commutes. Vehicles include well-maintained sedans and SUVs operated by trained chauffeurs for comfort and punctuality."
  },
  {
    "name": "Staff Pickup Drop Haldia Park",
    "description": "Staff Pickup Drop Haldia Park provides reliable daily employee transport with predefined routes, shift-aligned schedules, GPS tracking, and experienced drivers, ensuring seamless office commutes."
  },
  {
    "name": "Monthly Corporate Cab Haldia",
    "description": "Monthly Corporate Cab Haldia offers long-term corporate transportation with dedicated vehicles, trained drivers, route optimization, GPS monitoring, and full operational support for uninterrupted staff mobility."
  },
  {
    "name": "Affordable Cab Haldia",
    "description": "Affordable Cab Haldia provides cost-effective corporate transportation solutions for small to mid-sized companies without compromising on safety, punctuality, or comfort."
  },
  {
    "name": "Best Corporate Cab Haldia",
    "description": "Best Corporate Cab Haldia delivers premium-grade services with high-quality vehicles, skilled chauffeurs, and superior safety standards, ideal for executives, managers, and VIP staff."
  },
  {
    "name": "Outstation Cab Haldia",
    "description": "Outstation Cab Haldia provides long-distance corporate travel solutions for client visits, intercity meetings, and industrial trips. The service includes comfortable vehicles, trained drivers, GPS tracking, and interstate permits."
  },
  {
    "name": "Sedan Cab Haldia",
    "description": "Sedan Cab Haldia offers executive sedans for managerial commutes, airport runs, business trips, and daily office travel. Vehicles are well-maintained with professional chauffeurs ensuring a smooth and comfortable ride."
  },
  {
    "name": "SUV Cab Haldia",
    "description": "SUV Cab Haldia provides spacious, high-comfort SUVs suitable for senior management, team travel, and outstation trips, with trained drivers and advanced safety monitoring."
  },
  {
    "name": "Company Transport Haldia",
    "description": "Company Transport Haldia offers end-to-end corporate transport solutions including employee travel, executive transfers, and visitor mobility with professionally managed fleets and safety-compliant operations."
  },
  {
    "name": "Employee Mobility Haldia",
    "description": "Employee Mobility Haldia delivers flexible and tech-enabled commute solutions integrating GPS tracking, route optimization, and scheduling support for efficient workforce transportation."
  },
  {
    "name": "Corporate Fleet Haldia Park",
    "description": "Corporate Fleet Haldia Park provides fleet management services including vehicle maintenance, driver management, route planning, and scalable corporate transportation for companies operating in Haldia industrial areas."
  }
],

"tableData": [
  ["Haldia Industrial Cab", "Employee Shuttle Haldia"],
  ["Corporate Transport Haldia", "Factory Worker Transport Haldia"],
  ["Business Cab Haldia", "Staff Pickup Drop Haldia Park"],
  ["Monthly Corporate Cab Haldia", "Affordable Cab Haldia"],
  ["Best Corporate Cab Haldia", "Outstation Cab Haldia"],
  ["Sedan Cab Haldia", "SUV Cab Haldia"],
  ["Company Transport Haldia", "Employee Mobility Haldia"],
  ["Corporate Fleet Haldia Park", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Haldia Industrial Park",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Haldia Industrial Park, ensuring smooth and efficient transportation for employees and business executives across the industrial and commercial zones."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We ensure punctual pickups and drop-offs across Haldia Industrial Park, helping employees reach factories, offices, and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs provide safe, courteous, and disciplined travel, ensuring a secure and comfortable commute for corporate clients."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel in Haldia Industrial Park."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the commuting requirements of companies and employees in Haldia Industrial Park."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our team provides round-the-clock assistance for bookings, emergencies, and route adjustments, ensuring uninterrupted corporate travel."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are regularly sanitized and equipped with modern safety features, offering secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Corporate travel is managed effortlessly through our streamlined booking process and reliable coordination, making employee transport hassle-free."
  }
]















  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Haldia Industrial Park?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services for companies and industrial offices in Haldia Industrial Park.',
  },
  {
    question: 'What types of corporate transportation services are available in Haldia Industrial Park?',
    answer: 'We provide employee transportation, industrial shuttle services, corporate pickups and drops, airport transfers, and complete fleet management for corporate and industrial clients.',
  },
  {
    question: 'Do you support daily employee commute services in Haldia Industrial Park?',
    answer: 'Yes, we offer structured daily commute solutions with optimized routes, timely pickups, and multi-shift support for employees.',
  },
  {
    question: 'How can companies book corporate cab services in Haldia Industrial Park?',
    answer: 'Companies can book through our website, mobile app, or by contacting our 24×7 dedicated corporate support team.',
  },
  {
    question: 'Which vehicles are available for corporate cab services in Haldia Industrial Park?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, tempo travellers, luxury cars, and electric vehicles based on corporate requirements.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts in Haldia Industrial Park?',
    answer: 'Yes, we provide monthly, quarterly, and annual corporate transportation contracts with flexible pricing and comprehensive fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'All vehicles are GPS-enabled, regularly sanitized, and driven by trained and background-verified chauffeurs to ensure employee safety.',
  },
  {
    question: 'Do you provide transportation for night shifts and rotational shifts in Haldia Industrial Park?',
    answer: 'Absolutely. We provide reliable transport solutions for night shifts, early morning shifts, weekend operations, and rotational schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, credit/debit cards, digital wallets, and provide consolidated monthly corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Subrata Mukherjee',
    feedback: 'Reliable corporate cab service for our Haldia Industrial Park office. Vehicles are clean and drivers are punctual and professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Mousumi Dutta',
    feedback: 'Excellent transportation partner. Our employees are happy with the smooth, safe, and timely commute services.',
    rating: 5,
  },
];












































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Haldia Industrial Park",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-haldia.jpg", // replace with actual image URL
  "description":
    "Pune Corporate Cars India Private Limited provides professional corporate cab services in Haldia Industrial Park, including industrial cabs, employee shuttle, corporate transport, factory worker transport, business cabs, staff pickup & drop, monthly corporate cab rentals, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, company transport, employee mobility solutions, and complete corporate fleet management.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-haldia-industrial-park"
  }
};









  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Haldia Industrial Park | Employee & Industrial Transport</title>

  <meta
    name="description"
    content="Professional corporate cab services in Haldia Industrial Park including industrial cabs, employee shuttle, corporate transport, factory worker transport, business cabs, staff pickup & drop, monthly corporate cab rentals, affordable and executive cabs, outstation trips, sedan & SUV corporate cabs, company transport, employee mobility solutions, and corporate fleet management."
  />

  <meta
    name="keywords"
    content="Haldia Industrial Cab, Employee Shuttle Haldia, Corporate Transport Haldia, Factory Worker Transport Haldia, Business Cab Haldia, Staff Pickup Drop Haldia Park, Monthly Corporate Cab Haldia, Affordable Cab Haldia, Best Corporate Cab Haldia, Outstation Cab Haldia, Sedan Cab Haldia, SUV Cab Haldia, Company Transport Haldia, Employee Mobility Haldia, Corporate Fleet Haldia Park"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhaladia;